import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  useTranslate,
  DateField,
} from "react-admin";
import Box from "@mui/material/Box";

const GeneralLedgerExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <Box
      sx={{
        m: 5,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          // bgcolor: "rgba(0,0,0,.04)",
          // fontSize: "smaller",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "6px 8px",
            border: "1px solid #dddddd",
          },
        }}
      >
        <thead>
          <tr>
            <th style={{ width: "10.28%" }}>{t("mine.label.date")}</th>
            <th style={{ width: "10.28%" }}>{t("mine.label.code")}</th>
            <th style={{ width: "22.28%" }}>{t("mine.label.note")}</th>
            <th style={{ textAlign: "right", width: "14.28%" }}>
              {t("mine.label.previous")}
            </th>
            <th style={{ textAlign: "right", width: "14.28%" }}>
              {t("mine.label.debit")}
            </th>
            <th style={{ textAlign: "right", width: "14.28%" }}>
              {t("mine.label.credit")}
            </th>
            <th style={{ textAlign: "right", width: "14.28%" }}>
              {t("mine.label.final")}
            </th>
          </tr>
        </thead>
        <tbody>
          {(record.transactions ?? []).map((item, idx) => {
            return (
              <tr key={item.id + idx}>
                <td>
                  <RecordContextProvider value={item}>
                    <DateField
                      source="date"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td>{item.code}</td>
                {/* <TextField source="code" label="mine.label.code" /> */}
                <td>{item.description}</td>
                {/* <TextField source="description" label="mine.label.note" /> */}
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="previous"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="debit"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="credit"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="current"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Box>
  );
};

export default GeneralLedgerExpandList;
